import styled, { css } from "styled-components";

const WINDOW_MODE = {
  DEFAULT: "DEFAULT",
  COLLAPSED: "COLLAPSED",
};

const CHAT_MODE = {
  DEFAULT: 0,
  EXPANDED: 1,
  COLLAPSED: 2,
};

export const Container = styled.div`
  position: absolute;
  z-index: 999999;
  transition: ${(props) =>
    props.isDragging || props.isResizing ? "none" : "all 0.3s ease-in-out"};

  ${(props) =>
    props.windowMode === WINDOW_MODE.DEFAULT
      ? css`
          width: 100%;
          height: 100%;
          right: 0px;
          top: 0px;
        `
      : css`
          top: ${props.position
            ? `${props.position.y}px`
            : `${
                props?.mode === CHAT_MODE.DEFAULT ? "1rem" : "5rem"
              }`};
          left: ${props.position
            ? `${props.position.x}px`
            : "auto"};
          right: ${props.position
            ? "auto"
            : `calc(1rem + ${
                props?.mode === CHAT_MODE.COLLAPSED ? "300px" : "0px"
              })`};
          width: ${props.size ? `${props.size.width}px` : '380px'};
          height: ${props.size ? `${props.size.height}px` : '520px'};
          user-select: none;

          > div {
            border-radius: 10px;
          }

          .drag-bar {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 28px;
            background: rgba(0, 0, 0, 0.08);
            border-radius: 10px 10px 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: grab;
            z-index: 10;
            backdrop-filter: blur(5px);
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);
            transition: all 0.2s ease;

            &:hover {
              background: rgba(0, 0, 0, 0.12);
              
              svg {
                color: rgba(255, 255, 255, 0.9);
                transform: scale(1.1);
              }
            }

            &:active {
              cursor: grabbing;
              background: rgba(0, 0, 0, 0.18);
            }

            svg {
              font-size: 1.1rem;
              color: rgba(255, 255, 255, 0.6);
              transition: all 0.2s ease;
            }
          }

          .resize-handle {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 16px;
            height: 16px;
            cursor: nwse-resize;
            z-index: 10;
            background: rgba(0, 0, 0, 0.15);
            border-radius: 10px 0 10px 0;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: rgba(0, 0, 0, 0.25);
              width: 18px;
              height: 18px;
            }

            &:active {
              background: rgba(0, 0, 0, 0.35);
            }

            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background: linear-gradient(
                -45deg,
                transparent 30%,
                rgba(255, 255, 255, 0.6) 30%,
                rgba(255, 255, 255, 0.6) 35%,
                transparent 35%,
                transparent 65%,
                rgba(255, 255, 255, 0.6) 65%,
                rgba(255, 255, 255, 0.6) 70%,
                transparent 70%
              );
            }
          }
        `}
`; 

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 1rem;
  padding: 1rem;
  background-color: #3b3b4b;

  ${({ accessLevel }) =>
    accessLevel?.includes('ACESSIBILIDADE') &&
    css`
      background-color: #ffffff !important;
    `}
  
  ${(props) => props.windowMode === WINDOW_MODE.COLLAPSED && css`
    padding-top: 2.25rem;
  `}
`;

export const Mi4u = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 24px;
`;

export const NeuronMeet = styled.div`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 24px;
  background: linear-gradient(135deg, rgb(29 139 232) 0%, rgb(29 195 206) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: white;
  position: relative;
  overflow: hidden;

  ${({ accessLevel }) =>
    accessLevel?.includes('ACESSIBILIDADE') &&
    css`
      background: #ffffff !important;
      color: #000000 !important;

      .call-icon {
        background: #ffffff !important;
        border: 2px solid #000000 !important;
        color: #000000 !important;
        svg {
          color: #000000 !important;
        }
      }

      .ring {
        border-color: rgba(0, 0, 0, 0.3) !important;
      }

      .call-info h3,
      .call-info p {
        color: #000000 !important;
      }

      .link-container {
        background: #ffffff !important;
        border: 3px solid #000000 !important;
      }

      .link-input {
        color: #000000 !important;
        &::placeholder {
          color: rgba(0, 0, 0, 0.5) !important;
        }
      }

      .copy-button {
        background: #000000 !important;
        color: #ffffff !important;
        svg {
          color: #ffffff !important;
        }
      }
    `}

  .call-animation {
    position: relative;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .call-icon {
    font-size: 2rem;
    z-index: 2;
    position: relative;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    padding: 1rem 1rem .5rem 1rem;
    backdrop-filter: blur(10px);
  }

  .pulse-rings {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .ring {
    position: absolute;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  .ring-1 {
    width: 80px;
    height: 80px;
    top: -40px;
    left: -40px;
    animation-delay: 0s;
  }

  .ring-2 {
    width: 120px;
    height: 120px;
    top: -60px;
    left: -60px;
    animation-delay: 0.5s;
  }

  .ring-3 {
    width: 160px;
    height: 160px;
    top: -80px;
    left: -80px;
    animation-delay: 1s;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.8);
      opacity: 1;
    }
    100% {
      transform: scale(1.2);
      opacity: 0;
    }
  }

  .call-info {
    text-align: center;
    width: 100%;
    margin-top: 2rem;
  }

  .call-info h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .call-info p {
    margin: 0 0 1.5rem 0;
    opacity: 0.9;
    font-size: 0.98rem;
    line-height: 1.4;
  }

  .link-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .link-container {
    display: flex;
    gap: 0.5rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 0.5rem;
    backdrop-filter: blur(10px);
    max-width: 500px;
    width: 100%;
    margin-top: 2rem;
  }

  .link-input {
    flex: 1;
    background: transparent;
    border: none;
    color: white;
    font-size: 1.2rem;
    padding: 0.5rem;
    outline: none;
    text-align: center;
    &::placeholder {
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .copy-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }
`;
